const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
        .container {
            display: flex;
            flex-direction: column;
            background: #ffffff;
            border-radius: 5px;
            box-shadow: 0px 1px 10px rgb(66 66 66 / 15%);
            cursor: pointer;
            padding: 13px 0px;
            margin: 12px 0px; 
        }

        .container-channel {
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 2px solid #ECECEC;
            padding: 0px 16px 8px 16px
        }
        .container-channel .channel-logo {
            width: 32px;
            height: 32px;
            border: 1px solid #D9D9D9;
            border-radius: 20px;
            margin-right: 8px;
        }
        .container-channel p {
            margin: 0;
            font-weight: 400;
            font-size: 12px;
            line-height: 135%;
            color: #7F7F7F;
        }
        .container-channel h4 {
            margin: 0;
            font-weight: 600;
            font-size: 14px;
            line-height: 135%;
            color: #3570D2;
        }

        .container-content {
            padding: 0px 16px
        }
        .container-content .content-row h2 {
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            color: #4A4A4A;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .container-content .content-row {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin: 12px 0px;
        }
        .container-content .content-row .icon-content-black {
            width: 16px;
            height: 16px;
            margin-top: 4.5px;
            margin-right: 10px;
            margin-bottom: 5px;
        }
        .container-content .container-field {
            display: flex;
            flex-direction: row;
        }
        .container-content .content-field {
            display: flex;
            border: 1px solid #ECECEC;
            border-radius: 18px;
            padding: 4px 12px;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            line-height: 17px;
            color: #7F7F7F;
        }

        .text-content {
            display: flex;
            margin: 0;
            font-weight: 400;
            font-size: 16px;
            line-height: 14px;
            color: #424242;
            align-items: center;
        }
        .text-content-icon {
            width: 14px;
            height: 14px;
            margin-bottom: 2px;
            margin-right: 4px;
        }

        .container-skp-price {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .container-skp-price .text-skp {
            font-weight: 600;
            font-size: 16px;
            line-height: 19px;
            color: #F5A623;
        }
        .container-skp-price .content-text-price {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 4px 12px;
            border: 1px solid #ED6700;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            line-height: 135%;
            color: #ED6700;
        }
        .container-skp-price .content-text-registered {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            padding: 4px 12px;
            border: 1px solid #559808;
            border-radius: 4px;
            font-weight: 600;
            font-size: 14px;
            line-height: 135%;
            color: #559808;
        }
        .container-skp-price .icon-checklist {
            margin-bottom: 2px;
            margin-right: 7px;
        }

        .container-ecourse-passed {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 8px 149px;
            background: #E5EFFF;
            border: 1px solid #3570D2;
            border-radius: 4px;
            margin-top: 12px;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #424242;
            text-align: center;
        }

        .container-button-detail {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 12px;
        }
        .container-button-detail .button-detail {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            background: #ED6700;
            border-radius: 4px;
            font-weight: 600;
            font-size: 16px;
            line-height: 135%;
            color: #FFFFFF;
            cursor: pointer;
        }
        .container-button-detail .button-detail .icon-button-detail {
            margin-bottom: 2px;
            margin-right: 4px;
        }
    </style>
</template>`;

styleElement.register("ecourse-list-card-style");
